import { Link } from "react-router-dom";
import Cta from "../../Shared/Cta";
import React from "react";
import { useForm } from "react-hook-form";
import { error } from "jquery";
import {
  bloodOption,
  genderOptions,
  religionOption,
} from "../../utils/helpers";
import CustomSelect from "../../Shared/CustomSelect";
import CustomInput from "../../Shared/CustomInput";
import SubmitForm from "../../Shared/SubmitForm";
const AddParent = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    console.log("handlesubmit ", data);
  };
  return (
    <>
      <div class="breadcrumbs-area">
        <h3>Parents</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Add New Parents</li>
        </ul>
      </div>

      <div class="card height-auto">
        <div class="card-body">
          <div class="heading-layout1">
            <div class="item-title">
              <h3>Add New Parents</h3>
            </div>
            <Cta />
          </div>
          <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
            <div class="row">
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"First Name *"}
                  register={register}
                  errors={errors}
                  name={"firstname"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Last Name *"}
                  register={register}
                  errors={errors}
                  name={"lastname"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Gender *"}
                  register={register}
                  errors={errors}
                  name={"gender"}
                  placeholder={"Please Select Gender*"}
                  option={genderOptions}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Occupation"}
                  register={register}
                  errors={errors}
                  name={"occupation"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"ID NO *"}
                  register={register}
                  errors={errors}
                  name={"idNo"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Blood Group *"}
                  register={register}
                  errors={errors}
                  name={"bloodGroup"}
                  placeholder={"Please Select Group*"}
                  option={bloodOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomSelect
                  label={"Religion *"}
                  register={register}
                  errors={errors}
                  name={"religion"}
                  placeholder={"Please Select Religion*"}
                  option={religionOption}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Email"}
                  register={register}
                  errors={errors}
                  name={"email"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Address"}
                  register={register}
                  errors={errors}
                  name={"lastname"}
                />
              </div>
              <div class="col-xl-3 col-lg-6 col-12 form-group">
                <CustomInput
                  label={"Phone No *"}
                  register={register}
                  errors={errors}
                  name={"phone"}
                />
              </div>
              <div class="col-md-6 d-none d-xl-block"></div>
              <div class="col-lg-6 col-12 form-group">
                <label>Short BIO</label>
                <textarea
                  class="textarea form-control"
                  name="message"
                  id="form-message"
                  cols="10"
                  rows="9"
                  {...register("shortBio", {
                    required: "maximum 1400 character",
                  })}
                ></textarea>
                {errors.shortBio && (
                  <p style={{ color: "red" }}>{errors.shortBio.message}</p>
                )}
              </div>
              <div class="col-lg-6 col-12 form-group mg-t-30">
                <label class="text-dark-medium">
                  Upload Student Photo (150px X 150px)
                </label>
                <input type="file" class="form-control-file" />
              </div>
              <SubmitForm />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddParent;
